/* eslint-disable camelcase */
import React, { useState } from 'react';
import { ErrorMessage } from '../../common';
import { getErrorMessages } from '../../../utils';
import { TFreelancerData, TPageNotification } from '../../../types';
import LoadingSpinner from '../../common/LoadingSpinner';
import { executeHttpRequest } from '../../../epics/api';


type TArchiveFreelancersPrompt = {
    freelancer: TFreelancerData;
    onActionSuccess: () => void;
    closeModal: () => void;
    notification: TPageNotification;
}

export function ArchiveFreelancersPrompt({
    freelancer,
    onActionSuccess,
    closeModal,
    notification,
}: TArchiveFreelancersPrompt) {
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const handleConfirm = () => {
        setIsLoading(true);

        executeHttpRequest(
            `unallocated-freelancers/${freelancer.id}/`,
            'PATCH',
            { is_archived: true }
        ).then(() => {
            setIsLoading(false);
            closeModal();
            onActionSuccess();
            notification.success('Success', 'Worker archived successfully!');
        }).catch(err => {
            setIsLoading(false);
            setError(getErrorMessages(err));
        });
    };

    return (
        <div className="modal-dialog unallocated-freelancers-modal-container">
            <p className="modal-title">Archive worker</p>
            <div className="unallocated-freelancers-modal-body">
                <p>Are you sure you want to archive worker <strong>{freelancer.id}</strong>?</p>
            </div>
            <button
                className="btn btn--round-small"
                type="button"
                disabled={isLoading}
                onClick={handleConfirm}
            >
                {isLoading ? (
                    <LoadingSpinner
                        className="mass-booking-spinner"
                        backgroundColor="white"
                    />
                ) : (
                    'CONFIRM'
                )}
            </button>
            <button
                className="btn cancel-btn"
                type="button"
                onClick={closeModal}
            >
                CANCEL
            </button>
            {error && (
                <ErrorMessage message={error}/>
            )}
        </div>
    );
}
